export const SET_SEARCH_VAL = 'SET_QUESTIONS_SEARCH_VAL';
export const SET_FILTER_VISIBLE = 'SET_QUESTIONS_FILTER_VISIBLE';
export const SET_SELECTED_QUESTION = 'SET_SELECTED_QUESTION';
export const SET_PERIOD = 'SET_QUESTIONS_PERIOD';
export const SET_TYPES = 'SET_QUESTIONS_TYPES';
export const SET_STATES = 'SET_QUESTIONS_STATES';
export const SET_COMPANIES = 'SET_QUESTIONS_COMPANIES';
export const SET_STREETS = 'SET_QUESTIONS_STREETS';
export const SET_HOUSES = 'SET_QUESTIONS_HOUSES';
export const SET_ADDRESSES = 'SET_QUESTIONS_ADDRESSES';
export const RESET_FILTER = 'RESET_QUESTIONS_FILTER';
export const SET_IS_HTML = 'SET_QUESTIONS_IS_HTML';
export const SET_LOCAL_FILES = 'SET_QUESTIONS_LOCAL_FILES';
export const SET_EDITOR_STATE = 'SET_QUESTIONS_EDITOR_STATE';
export const SET_EDITOR_LINK_MODAL_DATA =
  'SET_QUESTIONS_EDITOR_LINK_MODAL_DATA';
export const SET_EDITOR_PHONE_MODAL_DATA =
  'SET_QUESTIONS_EDITOR_PHONE_MODAL_DATA';
export const SET_MESSAGE_AREA_STATE = 'SET_QUESTIONS_MESSAGE_AREA_STATE';
export const RESET_AREA_EDITOR_STATES = 'RESET_QUESTIONS_AREA_EDITOR_STATES';
export const SET_ANSWER_STATUS = 'SET_QUESTIONS_ANSWER_STATUS';
export const SET_CLOSE_QUESTION_REJECTED = 'SET_CLOSE_QUESTION_REJECTED';
export const SET_QUESTIONS_SORT_DATA = 'SET_QUESTIONS_SORT_DATA';
export const RESET_QUESTIONS_STORE = 'RESET_QUESTIONS_STORE';
export const SET_QUESTIONS_SAVED_DATA = 'SET_QUESTIONS_SAVED_DATA';
export const SET_IMPORTANT_QUESTIONS_FIRST = 'SET_IMPORTANT_QUESTIONS_FIRST';
export const SET_QUESTION_REACTION = 'SET_QUESTION_REACTION';
export const SET_NOTIFICATION_QUESTION = 'SET_NOTIFICATION_QUESTION';
